(function IIFE() {
    // ///////////////////////////

    function ContentService($state, AbstractContent, ContentFactory, ReduxStore) {
        'ngInject';

        const service = AbstractContent.createAbstractContentService(ContentFactory);

        // ///////////////////////////
        //                         //
        //          Redux          //
        //                         //
        // ///////////////////////////

        /**
         * Should retrun the service data that need to be synced with redux.
         *
         * @return The data. Aka. store shape.
         */
        function mapStateToRedux() {
            const currentContent = service.getCurrent();
            const action = service.getAction();
            const { params } = $state;

            const pickKeys = [
                "adminKeys",
                "author",
                "authorDetails",
                "authorId",
                "canContribute",
                "canEdit",
                "comments",
                "communityFeedKey",
                "communityIds",
                "communityType",
                "customContentType",
                "customContentTypeDetails",
                "customContentTypeTags",
                "driveFolder",
                "editors",
                "endDate",
                "endDateInput",
                "excerpt",
                "externalKey",
                "featuredFeedKeys",
                "featuredStartDate",
                "featuredStartDateInput",
                "featuredEndDate",
                "featuredEndDateInput",
                "feedKeys",
                "hasArticlesEnabled",
                "hasCommentWidget",
                "hasDriveFolder",
                "hasEventsEnabled",
                "headerDetails",
                "id",
                "isFeatured",
                "isHomepage",
                "lastPublishedAt",
                "lastRevision",
                "liked",
                "likes",
                "mediaThumbnail",
                "metadata",
                "notifyFeedKeys",
                "postTypes",
                "privacy",
                "privacy",
                "properties",
                "publicationDate",
                "renderingType",
                "securedRepository",
                "slug",
                "startDate",
                "startDateInput",
                "status",
                "template",
                "thumbnailAltText",
                "title",
                "type",
                "updatedAt",
                "updatedByDetails",
                "version",
                "writerDetails",
                "writerId"
            ];


            // Ensure everything is reset correctly when the current content is set.
            const defaults = pickKeys.reduce((acc, key) => ({
                ...acc,
                [key]: undefined,
            }), { metadataDetails: undefined });

            const pickedContent =_.pick(currentContent, [...pickKeys, 'metadataDetails']);

            return {
                id: '',
                entities: {},
                ...defaults,
                ...pickedContent,
                // Losing the ref of the title or the template triggers a lot of refresh on widgets in designer so we pass the angular object directly to redux
                title: currentContent?.title,
                template: currentContent?.template,
                currentContributionMode:
                    service.isDesignerInNewSimpleMode() && service.getCurrentContributionMode(),
                isDesignerMode: angular.isDefinedAndFilled(action) && action !== 'get',
                view: params ? params.view : null,
            };
        }

        function mapReduxToAngular(state) {
            /* Allow to reset the current content by trigger a redux update with an empty content.
             * This is usefull to notify Angular when that we are not a on a normal content page when accessing
             * Social advocacy dashboard. But we want to avoid to lose the current content so we check the $state.
             */
            const currentStateName = $state.current.name;

            if (!currentStateName.startsWith('app.front.content') && Object.keys(state).length === 0) {
                service.setCurrent(state);
            }

            /**
             * The content state `MetadataDetails` key can be set from the React application.
             * All changes made to the Content state in Redux needs to be replicated in the content service.
             * This is required in order for the change to be kept in the state when the content is updated.
             * */
            if (state.metadataDetails) {
                const currentContent = service.getCurrent();

                currentContent.metadataDetails = state.metadataDetails;
            }

        }

        // The namespace for this service in the redux store.
        service.reduxReducerName = 'content';

        // The action type triggered when Angular updated the state.
        service.reduxUpdateActionType = 'content/update';

        // Expose the appropriate functions.
        service.mapStateToRedux = mapStateToRedux;
        service.mapReduxToAngular = mapReduxToAngular;

        // ///////////////////////////

        /**
         * Initialize the controller.
         */
        service.initService = function initService() {
            // Enable Redux sync.
            ReduxStore.subscribe(service, true);

            service.init();
        };

        // ///////////////////////////

        return service;
    }

    // ///////////////////////////

    angular.module('Services').service('Content', ContentService);
})();
